<div class="heading-section">{{ 'documents.questions.create' | translate }}</div>
<lms-group-question-editor (onSave)="onSave($event)" [groupId]="groupId">
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="cancel()" form-actions-before></gl-button>
</lms-group-question-editor>
